import config from '@/config';

const getters = {
  config: () => config,
  sidebar: (state) => state.sidebar,
  notifications: (state) => state.notifications,
  breadcrumbs: (state) => state.breadcrumbs,
  countries: (state) => state.countries,
  storeConfig: (state) => state.config,
  stateProvince: (state) => state.stateProvince,
  warehouses: (state) => state.warehouses,
  languages: (state) => state.languages,
  currencies: (state) => state.currencies,
  stores: (state) => state.stores,
  store: (state) => state.store,
  isLoading: (state) => state.isLoading,
};

export default getters;
